import { IOption, IOptionGroup } from "../../classes/seating-option";
import * as React from 'react';
import Radio from './radio';

interface IRadioGroupProps {
    key?: string;
    id?: string;
    stateChangeFunction: (options: Array<IOption>, groupId: string) => void;
    selectedOptions?: Array<IOption>;
    group: IOptionGroup
    disabled: boolean;
}


interface IRadioGroupState {
}

class RadioGroup extends React.PureComponent<IRadioGroupProps, IRadioGroupState> {

    constructor(props) {
        super(props);
        //this.state = { selectedOptions: props.selectedOptions };
    }

    //componentWillReceiveProps(nextProps) {
    //    if (nextProps.selectedOptions !== undefined) {
    //        this.setState({ selectedOptions: nextProps.selectedOptions });
    //    }
    //}

    render() {
        return (
            <div>
                <ul>
                    {
                        this.props.group.options.filter(option => option.name != null && option.name.length > 0).map(option => {
                            // Mark if a selected option is in this option group.
                            //let match = this.state.selectedOptions != null ?
                            //    _.some(this.state.selectedOptions, seatingOption => option.id === seatingOption.id) : false;

                            return <Radio disabled={this.props.disabled} key={option.id}
                                onChangeFunction={this._selectOption}
                                checked={option.selected} option={option} optionGroup={this.props.group} />
                        }, this)
                    }
                </ul>
            </div>
        );
    }

    _selectOption = (option: IOption) => {
        this.props.group.options.map(option => {
            option.selected = false;
            return option;
        })

        option.selected = true;
        let newSeatingOptions = [option];

        this.props.stateChangeFunction(newSeatingOptions, this.props.group.id)
    }
}

export default RadioGroup;